/**
 * React Query keys for leads and lead events.
 * Prefer these factories for queries and invalidation — never ad-hoc string roots.
 */
export const leadsQueryKeys = {
  /** Prefix: all lead list caches (any workspace). */
  root: ['leads'] as const,
  all: (workspaceId: string) => ['leads', workspaceId] as const,
  /** Full lead list for a workspace (scope affects the cache entry). */
  list: (workspaceId: string, scope: string) =>
    ['leads', workspaceId, scope] as const,
  /** Single lead detail cache. */
  detail: (leadId: string) => ['lead', leadId] as const,
} as const;

export const leadEventsQueryKeys = {
  root: ['lead-events'] as const,
  all: (workspaceId: string) => ['lead-events', workspaceId] as const,
  detail: (workspaceId: string, eventId: string) =>
    ['lead-event', workspaceId, eventId] as const,
  leads: (workspaceId: string, eventId: string) =>
    ['lead-event-leads', workspaceId, eventId] as const,
  analytics: (workspaceId: string, eventId: string) =>
    ['lead-event-analytics', workspaceId, eventId] as const,
} as const;
